import { alpha, Box, IconButton, Stack, Typography } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import CopyIcon from "assets/svg/CopyIcon";
import ReceivedChartIcon from "assets/svg/ReceivedChartIcon";
import SendChartIcon from "assets/svg/SendChartIcon";
import { toast } from "react-toastify";
import theme, { responsiveFontSize } from "themes/Theme";
import { getStatusBgColor, trimHash } from "utils/common";
import { formateTransactionDate } from "utils/dateFormat";
import { formatNumber } from "utils/formatter";
import LinkIcon from "@mui/icons-material/Link";

export const transactionColumn: GridColDef[] = [
  {
    field: "id",
    headerName: "#",
    width: 90,
    renderCell: (params: GridRenderCellParams) =>
      params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
  },
  {
    field: "name",
    headerName: "User Name",
    minWidth: 200,
    flex: 1,
    valueGetter: (value, row) => `${row.firstName || ""} ${row.lastName || ""}`,
  },
  {
    field: "txHash",
    headerName: "Transaction Hash",
    minWidth: 180,
    flex: 1,
    renderCell: (params) => (
      <Stack
        direction={"row"}
        alignItems={"center"}
        sx={styles.height100}
        gap={1}
      >
        <Typography
          sx={{
            ...styles.textStyle,
            color:
              params.value !== "-"
                ? theme.palette.text.primary
                : theme.palette.text.primary,
          }}
        >
          {params.value !== "-" ? trimHash(params.value) : "-"}
        </Typography>
        {params.value !== "-" ? (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              window.open(
                `${process.env.REACT_APP_EXPLORE_URL}/tx/${params.value}`,
                "_blank",
                "noopener,noreferrer"
              );
            }}
          >
            <LinkIcon
              sx={{
                fontSize: 18,
                color: theme.palette.primary.light,
                "&:hover": {
                  color: theme.palette.primary.main,
                },
              }}
            />
          </IconButton>
        ) : null}
      </Stack>
    ),
  },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 140,
    flex: 1,
    renderCell: (params) => (
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography
          sx={{
            ...styles.textStyle,
            "& span": {
              fontSize: responsiveFontSize(12),
              color: theme.palette.primary.main,
            },
          }}
        >
          {formatNumber(params.value)} <span>{params.row.cryptoTicker}</span>
        </Typography>
      </Box>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 140,
    flex: 1,
    renderCell: (params) => (
      <Stack direction={"row"} alignItems={"center"} sx={styles.height100}>
        <Box
          sx={{
            ...styles.statusContainer,
            height: "30px",
            padding: "5px 10px",
            borderRadius: "8px",
            border: `1px solid ${alpha(
              getStatusBgColor(params.value.toLowerCase()),
              1
            )}`,
            backgroundColor: params.value
              ? alpha(getStatusBgColor(params.value.toLowerCase()), 0.1)
              : "",
          }}
        >
          <Typography
            sx={{
              ...styles.textStyle,
              color: getStatusBgColor(params.value.toLowerCase()),
            }}
          >
            {params.value}
          </Typography>
        </Box>
      </Stack>
    ),
  },
  {
    field: "txType",
    headerName: "Type",
    minWidth: 140,
    flex: 1,
    renderCell: (params) => (
      <Stack direction={"row"} alignItems={"center"} sx={styles.height100}>
        <Box sx={styles.statusContainer}>
          <Typography
            sx={{
              ...styles.textStyle,
              color:
                params.value.toLowerCase() === "receive"
                  ? theme.palette.custom?.green
                  : theme.palette.custom?.red,
            }}
          >
            {params.value}
          </Typography>

          {params.value.toLowerCase() === "receive" ? (
            <SendChartIcon color="green" />
          ) : (
            <ReceivedChartIcon color="red" />
          )}
        </Box>
      </Stack>
    ),
  },
  {
    field: "createdAt",
    headerName: "Transaction Date",
    minWidth: 140,
    flex: 1,
    renderCell: (params) => formateTransactionDate(params.value),
  },
];

const styles = {
  height100: {
    height: "100%",
  },
  statusContainer: {
    textTransform: "capitalize",
    alignSelf: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    fontWeight: 400,
    gap: 1,
  },
  textStyle: {
    fontSize: responsiveFontSize(14),
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
};
